<template>
  <div class="page-group">
    <div class="pre">
      <a @click="selectPage('pre')">
        <img :src="require('../../assets/images/arrow-page.svg')" alt="" :style="{ transform: 'rotate(270deg)' }">
      </a>
    </div>
    <div class="first" v-if="nowList[0] !== first">
      <a v-if="showFirst" @click="selectPage(first)">{{ first }}</a>
      <a class="ellipsis">...</a>
    </div>
    <div class="now">
      <a v-for="(n, i) in nowList" :key="i" :class="{ 'active': page === n, 'first': n === first, 'last': n === last }" @click="selectPage(n)">{{ n }}</a>
    </div>
    <div class="last" v-if="nowList[nowList.length - 1] !== last">
      <a class="ellipsis">...</a>
      <a v-if="showLast" @click="selectPage(last)">{{ last }}</a>
    </div>
    <div class="next">
      <a @click="selectPage('next')">
        <img :src="require('../../assets/images/arrow-page.svg')" alt="" :style="{ transform: 'rotate(90deg)' }">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    default: {
      type: Number,
      default: 1
    },
    display: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    buttonRange: {
      type: Number,
      default: 5
    },
    showFirst: {
      type: Boolean,
      default: true
    },
    showLast: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      page: this.default
    }
  },
  watch: {
    'page' (val) {
      this.fixRange()
    },
    'total' (val) {
      this.fixRange()
    },
    'display' (val) {
      this.fixRange()
    },
    'default' (val) {
      if (val) {
        this.page = val
      }
    }
  },
  computed: {
    first () {
      return 1
    },
    last () {
      return this.total > 0 && this.display > 0 ? Math.ceil(this.total / this.display) : 1
    },
    nowList () {
      return Array.from(new Array(this.buttonRange), (v, i) => i + this.page - Math.floor(this.buttonRange / 2)).filter(n => n >= this.first && n <= this.last)
    }
  },
  methods: {
    selectPage (page) {
      this.page = page !== 'pre' ? page !== 'next' ? page : Math.min(this.page + 1, this.last) : Math.max(this.page - 1, this.first)
      this.$emit('selectPage', this.page)
    },
    fixRange () {
      this.selectPage(this.page >= this.first ? this.page <= this.last ? this.page : this.last : this.first)
    }
  }
}
</script>

<style lang="sass">
.page-group
  width: 100%
  max-width: max-content
  text-align: center
  user-select: none
  display: flex
  justify-content: center
  align-items: center
  font-size: 0.7rem
  border-right: 1px solid #999999
  border-radius: 3px
  overflow: hidden
  // background: #999999
  & > div
    display: flex
    background: white
    &.pre
      & > a
        border-top-left-radius: 3px
        border-bottom-left-radius: 3px
    &.first
      & > a
        // &:first-child
        //   border-top-left-radius: 3px
        //   border-bottom-left-radius: 3px
    &.now
      & > a
        // &.first
        //   border-top-left-radius: 3px
        //   border-bottom-left-radius: 3px
        // &.last
        //   border-top-right-radius: 3px
        //   border-bottom-right-radius: 3px
    &.last
      & > a
        // &:last-child
        //   border-top-right-radius: 3px
        //   border-bottom-right-radius: 3px
    &.next
      & > a
        border-top-right-radius: 3px
        border-bottom-right-radius: 3px
    & > a
      height: 33px
      width: 33px
      margin-right: -1px
      border: 1px solid #999999
      color: #898989
      display: flex
      justify-content: center
      align-items: center
      &.ellipsis
        &:hover
          cursor: default
      &.active
        color: white
        background: #003C75
        font-weight: bold
      &:hover
        cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/tool/pageButtons.vue